import { useEffect, useState } from "react";

type Props = {
  data: {
    link: string | number | readonly string[] | undefined;
    id: number;
    name: string;
    description: string;
    isActive: boolean;

  };
  handleDelete: (id: number) => void;
  handleTheChange: (
    id: number,
    changedname: string,
    description: string,
    isActive: boolean
  ) => void;
};

export const AddLabel = (props: Props) => {
  const [name, setName] = useState(props.data.name);
  const [description, setDescription] = useState(props.data.description);
  const [isActive, setIsActive] = useState(props.data.isActive);

  useEffect(() => {
    props.handleTheChange(props.data.id, name, description, isActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, description, isActive]);

  return (
    <div className="w-full flex flex-row justify-center items-center px-6 mb-2">
      <div className="w-1/2 mr-2">
        <input
          type="text"
          name="name"
          className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent`}
          value={name}
          onChange={(e) => setName(e.target.value)}
          readOnly={name?.trim()?.toLocaleLowerCase() === "admin"}
          required
        />
      </div>

      <div className="w-1/2 mr-2">
        <input
          type="text"
          name="description"
          className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent`}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          readOnly={name?.trim()?.toLocaleLowerCase() === "admin"}
          required
        />
      </div>

      <div className="w-[10%] mr-2">
        <select
          name="active"
          className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent`}
          value={isActive ? "Yes" : "No"}
          disabled={name?.trim()?.toLocaleLowerCase() === "admin"}
          onChange={(e) => setIsActive(e.target.value === "Yes")}
        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div className="w-[5%]">
        {
          name?.trim()?.toLocaleLowerCase() !== "admin" && (
            <span
              className={`material-symbols-outlined text-[25px] font-medium text-red-500 cursor-pointer`}
              onClick={() => props.handleDelete(props.data.id)}
            >
              delete
            </span>
          )
        }
      </div>
    </div>
  );
};